import React from 'react'
import * as actionTypes from './actionTypes'
import axios from '../../axios-logged'
import jwtDecode from 'jwt-decode'
import { UncontrolledAlert } from 'reactstrap'
import {time, setCookie} from '../../shared/utility'

const saveToken = (token, data) => {
    const expirationDate = new Date((jwtDecode(token).exp + 7200) * 1000); // bloody miliseconds
    //const expirationDate = (jwtDecode(token).exp + 7200) * 1000; // bloody miliseconds
      //const expiresIn = Math.round((expirationDate.getTime() - time().getTime()) / 1000);
    let expiresIn = Math.round((expirationDate.getTime() - time().getTime()));

    if (typeof localStorage !== 'undefined') {
      localStorage.setItem('token', token);
      localStorage.setItem('expirationDate', expirationDate);
      localStorage.setItem('userId', data.userId);
      localStorage.setItem('role', data.role);
      localStorage.setItem('allow_export', data.allow_export);
      localStorage.setItem('allow_see_outcome_count', data.allow_see_outcome_count);
    }
    setCookie('token', token, 720);
    setCookie('expirationDate', expirationDate, 720);

    return expiresIn;
}

export const authStart = () => {
    return {
        type: actionTypes.AUTH_START
    }
}

export const ajaxLoading = () => {
    return {
        type: actionTypes.AUTH_AJAX_START
    }
}

export const authSuccess = (token, user, role, allow_export, allow_see_outcome_count) => {
    return {
        type: actionTypes.AUTH_SUCCESS,
        token: token,
        userId: user,
        role: role,
        allow_export: allow_export,
        allow_see_outcome_count: allow_see_outcome_count,
    }
}

export const passwordUpdated = token => {
    return {
        type: actionTypes.AUTH_PASSWORD_UPDATED,
        token: token,
    }
}

export const passwordUpdatedAlert = () => {
    alert = <UncontrolledAlert color="success">Password was updated</UncontrolledAlert>;
    return {
        type: actionTypes.GLOBAL_ALERT_OPEN,
        alert: alert,
    }
}

export const closeAlert = () => {
    return {
        type: actionTypes.GLOBAL_ALERT_CLOSE
    }
}

export const authFail = error => {
    return {
        type: actionTypes.AUTH_FAIL,
        error: error
    }
}

export const ajaxFail = error => {
    return {
        type: actionTypes.AUTH_AJAX_FAIL,
        error: error
    }
}

export const recoveryEmailSent = email => {
    return {
        type: actionTypes.AUTH_PASSWORD_RECOVERY_SENT,
        email: email
    }
}

export const auth = (email, password, isSignUp) => {
    return dispatch => {
        dispatch(authStart());

        const authData = {
            email: email,
            password: password
        };

        axios.post('/auth/login', authData)
        .then(response => {
            const token = response.data.access_token;
            const expiresIn = saveToken(token, response.data);
            dispatch(authSuccess(
                token,
                response.data.userId,
                response.data.role,
                response.data.allow_export,
                response.data.allow_see_outcome_count
            ));
            dispatch(checkOffTimeout(expiresIn));
        })
        .catch(err => {
            if(err.response){
              dispatch(authFail(err.response.data.message));
            }else{
              dispatch(authFail('Connection Error'));
            }
        })
    }
}

export const authSocialLogin = (social, res) => {

    return dispatch => {
        dispatch(authStart());

        axios.post('auth/' + social, res)
        .then(res => {
            const token = res.data.access_token;
            const expiresIn = saveToken(token, res.data);
            dispatch(authSuccess(
                token,
                res.data.userId,
                res.data.role,
                res.data.allow_export,
                res.data.allow_see_outcome_count
            ));
            dispatch(checkOffTimeout(expiresIn));
        })
        .catch(err => {
            if(err.res){
              dispatch(authFail(err.res.data.message));
            }else{
              dispatch(authFail('Connection Error'));
            }
        })
    }
}

export const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('expirationDate');
    localStorage.removeItem('userId');
    localStorage.removeItem('role');
    return {
        type: actionTypes.AUTH_LOGOUT
    }
}

export const checkOffTimeout = (expirationTime) => {
    return dispatch => {
        setTimeout(() => {
           // dispatch(logout());
        }, expirationTime * 1000)
    }
}

export const setAuthRedirectPath = (path) => {
    return {
        type: actionTypes.SET_AUTH_REDIRECT_PATH,
        path: path
    }
}

export const authCheckState = () => {
    return dispatch => {
        const token = localStorage.getItem('token');
        const userId = localStorage.getItem('userId');
        const role = localStorage.getItem('role');
        const allow_export = localStorage.getItem('allow_export');
        const allow_see_outcome_count = localStorage.getItem('allow_see_outcome_count');
        if(token){
            const now = new Date();
            const nowTimestamp = now.getTime();
            const expirationDate = new Date((jwtDecode(token).exp + 7200) * 1000); // bloody miliseconds

            if(nowTimestamp < expirationDate){
                dispatch(authSuccess(token, userId, role, allow_export, allow_see_outcome_count));

                const expiresIn = Math.round((expirationDate.getTime() - now.getTime()));
                dispatch(checkOffTimeout(expiresIn));
            }
        }
    }
}

export const authPasswordUpdate = (token, password) => {
    return dispatch => {

        axios.post('/auth/password', {password:password})
        .then(response => {

            const token = response.data.token;
            const expiresIn = saveToken(token);
            dispatch(passwordUpdated(token));
            dispatch(checkOffTimeout(expiresIn));

             // global success alert
            dispatch(passwordUpdatedAlert());
            // close alert after 10s
            setTimeout(() => {
                dispatch(closeAlert());
            }, 10 * 1000)
        })
        .catch(err => {
            console.log(err.response);
            if(err.response){
              dispatch(authFail(err.response.data.message));
            }else{
              dispatch(authFail('Connection Error'));
            }
        });
    }
}

export const passwordRecovery = email => {
    return dispatch => {
        dispatch(ajaxLoading());
        axios.post('/auth/password-recovery', {email:email})
        .then(response => {
            dispatch(recoveryEmailSent(email));
        })
        .catch(err => {
            console.log(err.response);
            dispatch(ajaxFail(err.response.data.message));
        });
    }
}

export const passwordRecoveryChange = (email, token, password) => {
    const data = {
        email: email,
        token: token,
        password: password
    };
    return dispatch => {
        dispatch(ajaxLoading());
        axios.put('/auth/password-recovery', data)
        .then(response => {
            const token = response.data.token;
            const expiresIn = saveToken(token);
            dispatch(authSuccess(token, null));
            dispatch(checkOffTimeout(expiresIn));
        })
        .catch(err => {
            dispatch(ajaxFail(err.response.data.message))
        })
    }
}
